// extracted by mini-css-extract-plugin
module.exports = {"btn":"TagButton-styles-module--btn--2ZFJA","active":"TagButton-styles-module--active--1VO-k"};